import React from "react";
import css from "./stageProgressBar.module.scss";

type ProgressVariant = "complete" | "partial" | "error" | "empty";

interface StageProgressBarProps {
  percentage: number;
  variant?: ProgressVariant;
}

const StageProgressBar: React.FC<StageProgressBarProps> = ({ percentage, variant }) => {
  const clamped = Math.min(100, Math.max(0, percentage));

  return (
    <div className={css.track}>
      <div
        className={`${css.fill} ${css[`fill__${variant}`]}`}
        style={{ width: `${clamped}%` }}
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      />
    </div>
  );
};

export default StageProgressBar;
